export enum UserRole {
    LobbyAdministrator = 'LobbyAdministrator',
    LobbyAgent = 'LobbyAgent',
    LobbyAgentManager = 'LobbyAgentManager',
    LobbyAgentSupervisor = 'LobbyAgentSupervisor',
    LobbyLeadManager = 'LobbyLeadManager',
    LobbyAuthorized = 'LobbyAuthorized',
    AmministratoriRete = 'AmministratoriRete'
}